// src/pages/RHInbox.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ENDPOINTS } from "../Utils/Endpoints";
import { Models } from "../Utils/ModelsCarBooking";
import { TIPO_APROBACION } from "../Utils/reservationConstants";

import './../../../style/Vars.css';
import './../../../style/ElementsStyle.css';
import './../../../style/ContainersStyles.css';
import "../Styles/RHInbox.css";
import "../Styles/Drivers.css";

// 🔹 Usuario en sesión
import {
  getSessionUserId,
  getSessionUserName,
  getSessionEmpresaId,
} from "../../../utils/SessionUser";

import ConfirmDialog from "../../Lms/Components/Shared/ConfirmDialog";
import AlertDialog from "../../Lms/Components/Shared/AlertDialog";

const endpointReservas = ENDPOINTS.reserva;
const modeloReservas = Models.reserva;

const endpointChoferes = ENDPOINTS.chofer;
const modeloChofer = Models.chofer;

const endpointEmpleado = ENDPOINTS.empleados;
const modeloEmpleado = Models.empleados;

const endpointSolicitantes = ENDPOINTS.solicitantes;
const modeloSolicitantes = Models.solicitantes;

const endpointPersona = ENDPOINTS.personas;
const modeloPersona = Models.persona;

const endpointCorreo = ENDPOINTS.correos;
const modeloCorreo = Models.correos;

// 🔹 Usuarios + Aprobadores + Aprobaciones
const endpointUsuarios = ENDPOINTS.usuarios;
const endpointAprobadores = ENDPOINTS.aprobadores;
const modeloAprobador = Models.aprobadores;
const endpointAprobaciones = ENDPOINTS.aprobacionesReservas;

// 🔹 Tipos de Aprobación
const endpointTipoAprobacion = ENDPOINTS.tipoAprobacion;
const modeloTipoAprobacion = Models.tipoAprobacion;

// 🔹 Extras (semana / mes)
const endpointExtrasMes = ENDPOINTS.extrasAcumuladoMes;
const modeloExtrasMes = Models.extrasAcumuladoMes;

const endpointExtrasSemana = ENDPOINTS.extrasAcumuladoSemana;
const modeloExtrasSemana = Models.extrasAcumuladoSemana;

// 🔹 Turnos y asignación Empleado ↔ Turno (para calcular horario del chofer)
const endpointTurnos = ENDPOINTS.turnos;
const modeloTurnos = Models.turnos;

const endpointEmpleadoTurno = ENDPOINTS.empleadosTurnos;
const modeloEmpleadoTurnos = Models.empleadosTurnos;
const endpointUnidadesOrgEmpleado = ENDPOINTS.unidadesOrgEmpleado;
const modeloUnidadesOrgEmpleado = Models.unidadOrgEmpleado;

// 🆕 Parámetros laborales (límites de horas extra por UO)
const endpointParametrosLaborales = ENDPOINTS.parametrosLaborales;
const modeloParametrosLaborales = Models.parametrosLaborales;

// --- Helpers de fecha/hora (alineados con ReservationPage) --- //

function formatDateLocal(d) {
  if (!d) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`; // YYYY-MM-DD
}

function toDateWithTime(dateStr, timeStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const [hh = 0, mm = 0] = (timeStr || "00:00").split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, 0, 0);
}

function formatDateTimeRange(start, end) {
  if (!(start instanceof Date) || !(end instanceof Date)) return "";
  const sameDate = start.toDateString() === end.toDateString();
  const startDate = start.toLocaleDateString("es-MX");
  const endDate = end.toLocaleDateString("es-MX");
  const startTime = start.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" });
  const endTime = end.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" });

  if (sameDate) {
    return `${startDate} · ${startTime} - ${endTime}`;
  }

  return `${startDate} · ${startTime} → ${endDate} · ${endTime}`;
}

function parseJsonLocation(value) {
  if (!value) return { address: "", location: null };
  try {
    const v = typeof value === "string" ? JSON.parse(value) : value;
    if (v && typeof v === "object") {
      return {
        address: v.address || v.direccion || "",
        location: v.location || null,
      };
    }
  } catch {
    return { address: String(value || ""), location: null };
  }
  return { address: "", location: null };
}

// 🔹 Semana ISO (para cruzar con ExtrasAcumuladoSemana.semana)
function getISOWeek(date) {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

// 🔹 Festivos y fines de semana (alineados con ReservationPage)
const FESTIVOS_FIJOS = [
  "2025-01-01",
];

function isWeekend(date) {
  const day = date.getDay(); // 0 = domingo, 6 = sábado
  return day === 0 || day === 6;
}

function isHoliday(date) {
  const ymd = formatDateLocal(date);
  return FESTIVOS_FIJOS.includes(ymd);
}

function toMinutes(hm) {
  const [h, m] = (hm || "0:0").split(":").map(Number);
  return h * 60 + m;
}

// 🆕 Cálculo de minutos extra NETOS (fuera del turno del chofer)
function computeNetExtraMinutes(startHM, endHM, intervals) {
  const s = toMinutes(startHM);
  const e = toMinutes(endHM);
  if (e <= s) return 0;

  const duration = e - s;
  if (!intervals || intervals.length === 0) {
    // Sin turnos → todo cuenta como extra
    return duration;
  }

  let covered = 0;

  for (const iv of intervals) {
    const ivStart = toMinutes(iv.start);
    const ivEnd = toMinutes(iv.end);
    const overlapStart = Math.max(s, ivStart);
    const overlapEnd = Math.min(e, ivEnd);

    if (overlapEnd > overlapStart) {
      covered += overlapEnd - overlapStart;
    }
  }

  const extra = duration - Math.min(covered, duration);
  return Math.max(0, extra);
}

// Mapeo de reserva cruda (desde la API) → evento base
function mapReservaToEvent(r) {
  const id =
    r.idReserva ??
    r.IdReserva ??
    r.id ??
    r.Id ??
    0;

  const normalizeDate = (val) => {
    if (!val) return formatDateLocal(new Date());

    if (val instanceof Date) {
      return formatDateLocal(val);
    }
    const s = String(val);
    return s.slice(0, 10); // '2025-11-15T00:02:31.836Z' → '2025-11-15'
  };

  const rawFechaInicio =
    r.fechaInicio ??
    r.FechaInicio ??
    new Date().toISOString();

  const rawFechaFin =
    r.fechaFin ??
    r.FechaFin ??
    rawFechaInicio;

  const fecha = normalizeDate(rawFechaInicio);
  const fechaFin = normalizeDate(rawFechaFin);

  const normalizeHour = (val) => {
    if (!val) return "00:00";
    const s = String(val); // '08:30:00' o '08:30'
    return s.slice(0, 5); // '08:30'
  };

  const horaInicio = normalizeHour(r.horaInicio ?? r.HoraInicio ?? "00:00");
  const horaFin = normalizeHour(r.horaFin ?? r.HoraFin ?? "00:00");

  const start = toDateWithTime(fecha, horaInicio);
  const end = toDateWithTime(fechaFin, horaFin);

  const origenTexto = r.origenTexto ?? r.OrigenTexto ?? "";
  const destinoTexto = r.destinoTexto ?? r.DestinoTexto ?? "";

  const origin = parseJsonLocation(origenTexto);
  const destination = parseJsonLocation(destinoTexto);

  const idEstado =
    r.idEstadoReserva ??
    r.IdEstadoReserva ??
    0;

  // Tipo de aprobación asociado a la reserva
  // El modelo solo tiene idTipoAprobacion (no idTipoAprobacionReserva)
  const idTipoAprobacion =
    r.idTipoAprobacion ??
    r.IdTipoAprobacion ??
    null;

  // 1 = Pendiente, 3 = Confirmada, 4 = Rechazada (para fines visuales aquí)
  let estado;
  if (idEstado === 3) estado = "APROBADA";
  else if (idEstado === 4) estado = "RECHAZADA";
  else estado = "PENDIENTE";

  const meta = {
    idReserva: id,
    idSolicitante: r.idSolicitante ?? r.IdSolicitante ?? 0,
    idChofer: r.idChofer ?? r.IdChofer ?? 0,

    // 🔹 Fechas normalizadas (YYYY-MM-DD) para evitar problemas de zona horaria
    fechaInicio: fecha,
    fechaFin: fechaFin,

    motivo: r.motivo ?? r.Motivo ?? "",
    observaciones: r.observaciones ?? r.Observaciones ?? "",

    origin,
    destination,
    origenTexto,
    destinoTexto,

    estado,
    idEstadoReserva: idEstado,
    fueraHorarioMin: r.fueraHorarioMin ?? r.FueraHorarioMin ?? false,

    // 🔹 Asignar a ambos campos para compatibilidad
    idTipoAprobacion: idTipoAprobacion,
    idTipoAprobacionReserva: idTipoAprobacion,

    // se llenarán después con joins:
    chofer: "",
    emailChofer: "",
    nombre: "",             // nombre del SOLICITANTE
    emailSolicitante: "",

    // extras (semana / mes)
    extrasSemanaHoras: 0,
    extrasMesHoras: 0,

    // 🆕 horas extra netas de ESTA reserva
    horasExtraNetas: 0,
  };

  return {
    id,
    start,
    end,
    title: meta.motivo || "Reserva",
    meta,
  };
}

export default function RHInbox() {
  const [allEvents, setAllEvents] = useState([]);   // todas las reservas mapeadas
  const [parametrosLaborales, setParametrosLaborales] = useState([]); // 🆕
  const [pending, setPending] = useState([]);       // reservas filtradas que se muestran
  const [selected, setSelected] = useState(null);
  const [comment, setComment] = useState("");
  const [empleadoUnidadOrg, setEmpleadoUnidadOrg] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, title: "", message: "", variant: "info" });
  const [alertDialog, setAlertDialog] = useState({ open: false, title: "Información", message: "", variant: "info" });

  // 🔹 Usuario de sesión (RH)
  const [sessionUserId] = useState(() => getSessionUserId());
  const [sessionUserName] = useState(() => getSessionUserName());
  const [idAprobadorSesion, setIdAprobadorSesion] = useState(0);
  const [sessionEmpresaId] = useState(() => getSessionEmpresaId());
  const [tiposAprobacionSesion, setTiposAprobacionSesion] = useState([]);
  const [catalogoTipoAprobacion, setCatalogoTipoAprobacion] = useState([]);
  const [tiposLoaded, setTiposLoaded] = useState(false); // sabemos ya qué tipos tiene asignados
  const [showAll, setShowAll] = useState(false);         // toggle: solo mis tipos / todas
  const [aprobadorUoIds, setAprobadorUoIds] = useState([]);

  // 🔹 Errores críticos de sesión (bloquean toda la ventana)
  const [sessionErrors, setSessionErrors] = useState([]);
  const hasSessionErrors = sessionErrors.length > 0;

  // Carga optimizada: Reservas Enriquecidas + Turnos + Parametros
  async function load() {
    try {
      const [
        resReservasEnriched,
        resTurnos,
        resEmpleadosTurnos,
        resParametros,
        resUnidadesOrg, // Mantenemos para logica de sesión de aprobador
      ] = await Promise.all([
        axios.get(`${ENDPOINTS.reservasInboxRH}?_t=${Date.now()}`),
        axios.get(endpointTurnos),
        axios.get(endpointEmpleadoTurno),
        axios.get(endpointParametrosLaborales),
        axios.get(endpointUnidadesOrgEmpleado),
      ]);

      const rawReservas = resReservasEnriched.data || [];
      const turnosAll = (resTurnos.data || []).map(modeloTurnos);
      const empleadosTurnosAll = (resEmpleadosTurnos.data || []).map(modeloEmpleadoTurnos);
      const parametrosAll = (resParametros.data || []).map(modeloParametrosLaborales);

      const unidadesOrgEmpleadoAll = (resUnidadesOrg.data || []).map(modeloUnidadesOrgEmpleado);
      setEmpleadoUnidadOrg(unidadesOrgEmpleadoAll); // Necesario para la sesión del aprobador
      setParametrosLaborales(parametrosAll);

      // Cache para intervalos de turnos (ahora indexado por IdEmpleado, no IdChofer, o mapeamos)
      // La logica original usaba 'buildIntervalsForChofer' que buscaba IdEmpleado.
      // Ahora tenemos IdEmpleado directo en el DTO (choferEmpId).
      const cacheIntervalsByEmp = {};

      function buildIntervalsForEmployee(idEmpleado) {
        if (!idEmpleado) return [];
        if (cacheIntervalsByEmp[idEmpleado]) return cacheIntervalsByEmp[idEmpleado];

        // Filtrar asignaciones de turno para este empleado
        const asignaciones = empleadosTurnosAll.filter(et => et.idEmpleado === idEmpleado);
        if (!asignaciones.length) {
          cacheIntervalsByEmp[idEmpleado] = [];
          return [];
        }

        const turnoIds = [...new Set(asignaciones.map(a => a.idTurno).filter(Boolean))];
        const intervals = turnoIds
          .map(idT => turnosAll.find(t => t.idTurno === idT))
          .filter(Boolean)
          .map(t => ({
            start: String(t.horaInicio || "").slice(0, 5),
            end: String(t.horaFin || "").slice(0, 5),
          }));

        cacheIntervalsByEmp[idEmpleado] = intervals;
        return intervals;
      }

      const mapped = rawReservas.map((r) => {
        // Mapear campos estándar
        const ev = mapReservaToEvent(r);

        // Campos enriquecidos del DTO
        const choferNombre = r.choferNombre || r.ChoferNombre || "";
        const choferEmail = r.choferEmail || r.ChoferEmail || "";
        const choferEmpId = r.choferEmpId || r.ChoferEmpId || 0;
        const choferUOs = r.choferUOs || r.ChoferUOs || "";
        const solicitanteNombre = r.solicitanteNombre || r.SolicitanteNombre || "";
        const solicitanteEmail = r.solicitanteEmail || r.SolicitanteEmail || "";
        const extrasSemana = r.extrasSemana || r.ExtrasSemana || 0;
        const extrasMes = r.extrasMes || r.ExtrasMes || 0;

        // 🔹 ASIGNACIÓN DIRECTA DESDE API (Optimizado)
        ev.meta.chofer = choferNombre;
        ev.meta.emailChofer = choferEmail;
        ev.meta.choferEmpId = choferEmpId;
        ev.meta.choferUoIds = choferUOs ? String(choferUOs).split(',').map(Number) : [];

        ev.meta.nombre = solicitanteNombre;
        ev.meta.emailSolicitante = solicitanteEmail;

        ev.meta.extrasSemanaHoras = extrasSemana;
        ev.meta.extrasMesHoras = extrasMes;

        // Horas extra netas de ESTA reserva (el DTO ya debería traerlo o se calcula rápido aquí)
        // Por ahora mantenemos el cálculo local de la reserva actual para mayor precisión en tiempo real
        // pero evitamos los acumulados pesados.
        ev.meta.choferIntervals = buildIntervalsForEmployee(choferEmpId);

        let horasExtraNetas = 0;
        if (ev.start && ev.end && choferEmpId) {
            const hmStart = ev.start.toTimeString().slice(0, 5);
            const hmEnd = ev.end.toTimeString().slice(0, 5);
            const intervals = ev.meta.choferIntervals;
            
            if (isWeekend(ev.start) || isHoliday(ev.start)) {
                horasExtraNetas = Math.max(0, (toMinutes(hmEnd) - toMinutes(hmStart)) / 60);
            } else {
                horasExtraNetas = computeNetExtraMinutes(hmStart, hmEnd, intervals) / 60;
            }
        }
        ev.meta.horasExtraNetas = Math.floor(horasExtraNetas);
        return ev;
      });

      setAllEvents(mapped);
      setSelected(null);
      setComment("");
      return mapped;

    } catch (err) {
      console.error(err);
      setAlertDialog({
        open: true,
        title: "Error",
        message: "Error al cargar solicitudes de RH (Inbox Optimizado)",
        variant: "error"
      });
      return [];
    }
  }




  // 🔹 Helper para calcular el tipo de aprobación EFECTIVO
  // (Reevalúa si una reserva realmente excede los límites semanal/mensual
  //  tomando en cuenta parámetros laborales vigentes por fecha y UO).
  const getSimulatedApprovalType = (targetReserva, contextEvents = null) => {
    console.log(`\n[getSimulatedApprovalType] ▶️ INICIANDO para reserva #${targetReserva?.id}`);

    // Usar contextEvents si se proporciona, sino usar allEvents del estado
    const eventsToUse = contextEvents || allEvents;

    console.log(`[getSimulatedApprovalType] - Usando ${eventsToUse?.length || 0} eventos para cálculo`);

    const storedTypeId = targetReserva.meta?.idTipoAprobacionReserva ??
      targetReserva.meta?.idTipoAprobacion ?? 1;

    // Sólo recalculamos para tipos ligados a horas extra.
    const tiposRecalculables = new Set([
      TIPO_APROBACION.FUERA_HORARIO,
      TIPO_APROBACION.HORAS_SEMANA_EXCEDIDAS,
      TIPO_APROBACION.HORAS_MES_EXCEDIDAS,
    ]);

    if (!tiposRecalculables.has(storedTypeId)) {
      return storedTypeId;
    }

    const thisNetHours = Number(targetReserva.meta?.horasExtraNetas) || 0;
    // Si no suma horas, mantenemos el tipo original
    if (thisNetHours <= 0) return storedTypeId;

    const choferUoIds = targetReserva.meta?.choferUoIds || [];

    console.log(`[getSimulatedApprovalType] - choferUoIds: [${choferUoIds.join(', ')}]`);
    console.log(`[getSimulatedApprovalType] - parametrosLaborales totales: ${parametrosLaborales.length}`);

    // Buscar parámetro laboral cuya UO coincida (SIN validar vigencia)
    const param = parametrosLaborales.find((p) =>
      choferUoIds.includes(p.idUnidadOrganizacional)
    );

    console.log(`[getSimulatedApprovalType] - Parámetro encontrado: ${param ? 'SÍ (UO=' + param.idUnidadOrganizacional + ', Semanal=' + param.topeSemanalMin + 'h, Mensual=' + param.topeMensualMin + 'h)' : 'NO'}`);

    // Si NO hay parámetro para esta UO, no se marcan excedidas
    if (!param) {
      console.log(`[getSimulatedApprovalType] ⚠️ NO SE ENCONTRÓ PARÁMETRO LABORAL PARA ESTA UO → Retornando FUERA_HORARIO`);
      return TIPO_APROBACION.FUERA_HORARIO;
    }

    // Los campos se llaman "topeSemanalMin" y "topeMensualMin" pero en realidad contienen HORAS
    const limiteSemanalHoras = Number(param.topeSemanalMin) > 0
      ? Number(param.topeSemanalMin)
      : null;
    const limiteMensualHoras = Number(param.topeMensualMin) > 0
      ? Number(param.topeMensualMin)
      : null;

    // 🔹 USAR ACUMULADOS DE LA BD (ya calculados en la función load())
    // Estos valores vienen de las tablas ExtrasAcumuladoSemana y ExtrasAcumuladoMes
    // y se actualizan cuando se aprueban reservas o se modifican parámetros laborales
    const horasAprobadasSemana = Number(targetReserva.meta?.extrasSemanaHoras) || 0;
    const horasAprobadasMes = Number(targetReserva.meta?.extrasMesHoras) || 0;

    // Sumar horas PENDIENTES que sean PREVIAS a esta reserva (simulación de cola)
    let pendingPriorWeek = 0;
    let pendingPriorMonth = 0;

    // Auxiliares de fecha
    const isSameISOWeek = (d1, d2) => {
      if (!(d1 instanceof Date) || !(d2 instanceof Date)) return false;
      const w1 = getISOWeek(d1);
      const y1 = d1.getFullYear();
      const w2 = getISOWeek(d2);
      const y2 = d2.getFullYear();
      return w1 === w2 && y1 === y2;
    };

    const isSameMonth = (d1, d2) => {
      if (!(d1 instanceof Date) || !(d2 instanceof Date)) return false;
      return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    };

    if (eventsToUse && eventsToUse.length > 0) {
      // Filtramos eventos PENDIENTES del MISMO chofer
      const driverPendingEvents = eventsToUse.filter(ev =>
        ev.meta?.idChofer === targetReserva.meta?.idChofer &&
        Number(ev.meta?.idEstadoReserva) === 1 && // Solo pendientes
        ev.id !== targetReserva.id // Excluir la reserva actual
      );

      driverPendingEvents.forEach(ev => {
        const evHours = Number(ev.meta?.horasExtraNetas) || 0;
        if (evHours <= 0) return;

        // Determinar si 'ev' va antes que 'targetReserva'
        const isBefore =
          ev.start < targetReserva.start ||
          (ev.start.getTime() === targetReserva.start.getTime() && ev.id < targetReserva.id);

        if (isBefore) {
          if (isSameISOWeek(ev.start, targetReserva.start)) {
            pendingPriorWeek += evHours;
          }
          if (isSameMonth(ev.start, targetReserva.start)) {
            pendingPriorMonth += evHours;
          }
        }
      });
    }

    // Total = Horas Aprobadas (desde BD) + Pendientes Previas + Actual
    const totalMonth = horasAprobadasMes + pendingPriorMonth + thisNetHours;
    const totalWeek = horasAprobadasSemana + pendingPriorWeek + thisNetHours;

    console.log(`[getSimulatedApprovalType] Reserva #${targetReserva.id}:`);
    console.log(`  - Horas netas de esta reserva: ${thisNetHours}h`);
    console.log(`  - Horas APROBADAS (BD) semana: ${horasAprobadasSemana}h`);
    console.log(`  - Horas PENDIENTES previas semana: ${pendingPriorWeek}h`);
    console.log(`  - TOTAL SEMANA: ${totalWeek}h (${horasAprobadasSemana} + ${pendingPriorWeek} + ${thisNetHours})`);
    console.log(`  - Horas APROBADAS (BD) mes: ${horasAprobadasMes}h`);
    console.log(`  - Horas PENDIENTES previas mes: ${pendingPriorMonth}h`);
    console.log(`  - TOTAL MES: ${totalMonth}h (${horasAprobadasMes} + ${pendingPriorMonth} + ${thisNetHours})`);
    console.log(`  - Límite semanal: ${limiteSemanalHoras}h`);
    console.log(`  - Límite mensual: ${limiteMensualHoras}h`);

    // Prioridad 1: Excede Mes (sólo si hay límite configurado)
    if (limiteMensualHoras != null && totalMonth > limiteMensualHoras) {
      console.log(`  → RESULTADO: HORAS_MES_EXCEDIDAS (${totalMonth}h > ${limiteMensualHoras}h)`);
      return TIPO_APROBACION.HORAS_MES_EXCEDIDAS;
    }

    // Prioridad 2: Excede Semana (sólo si hay límite configurado)
    if (limiteSemanalHoras != null && totalWeek > limiteSemanalHoras) {
      console.log(`  → RESULTADO: HORAS_SEMANA_EXCEDIDAS (${totalWeek}h > ${limiteSemanalHoras}h)`);
      return TIPO_APROBACION.HORAS_SEMANA_EXCEDIDAS;
    }

    console.log(`  → RESULTADO: FUERA_HORARIO (dentro de límites)`);
    return TIPO_APROBACION.FUERA_HORARIO;
  };

  useEffect(() => {
    load();
  }, []);

  // 🔹 Filtrado de reservas según tipos de aprobación y toggle showAll
  useEffect(() => {
    if (!allEvents.length) {
      setPending([]);
      return;
    }

    // Si solo quiero mis tipos pero aún no sé qué tipos tengo, no muestro nada
    if (!showAll && !tiposLoaded) {
      setPending([]);
      return;
    }

    let base = allEvents;

    if (!showAll) {
      const allowedIds = new Set(
        tiposAprobacionSesion.map((t) => t.idTipoAprobacion)
      );

      // Si el usuario tiene tipo GENERAL (9), puede ver todas las reservas
      const hasGeneralPermission = allowedIds.has(9);

      if (!hasGeneralPermission) {
        base = base.filter((ev) => {
          // 🔹 FILTRO SIMPLE: usar SOLO el tipo almacenado en la BD
          // El tipo se actualiza cuando se modifican parámetros laborales o se aprueban reservas
          const tipoAlmacenado = ev.meta?.idTipoAprobacionReserva ?? ev.meta?.idTipoAprobacion;

          // Mostrar solo si el tipo almacenado está en mis permisos
          return tipoAlmacenado && allowedIds.has(tipoAlmacenado);
        });
      }
    }

    if (aprobadorUoIds.length > 0) {
      const aprobUoSet = new Set(aprobadorUoIds);
      base = base.filter((ev) => {
        const choferUoIds = ev.meta?.choferUoIds || [];
        if (!choferUoIds.length) return false;
        return choferUoIds.some((uoId) => aprobUoSet.has(Number(uoId)));
      });
    }

    const pend = base.filter((e) => Number(e.meta?.idEstadoReserva) === 1);

    // 🔹 Ordenar por fecha y hora de inicio (más cercano a más lejano)
    pend.sort((a, b) => {
      const dateA = a.start instanceof Date ? a.start : new Date(a.start);
      const dateB = b.start instanceof Date ? b.start : new Date(b.start);
      return dateA.getTime() - dateB.getTime();
    });

    setPending(pend);
  }, [allEvents, tiposAprobacionSesion, showAll, tiposLoaded, aprobadorUoIds]);

  // 🔹 Vincular idUsuario (sesión) → Persona → Empleado → Aprobador (+ tipos de aprobación)
  useEffect(() => {
    let cancel = false;

    async function loadAprobadorFromSession() {
      const errors = [];

      try {
        // 0) idUsuario en sesión
        if (!sessionUserId) {
          const msg =
            "[RHInbox] No hay idUsuario en sesión; no se puede operar esta pantalla.";
          console.warn(msg);
          errors.push(
            "No se detecta un usuario en sesión. No es posible operar la bandeja de RH."
          );
        } else {
          // 1) Usuarios: obtener TODOS y filtrar por idUsuario
          const resUser = await axios.get(endpointUsuarios);
          const usuariosRaw = resUser.data || [];

          const rawUser =
            usuariosRaw.find((u) => {
              const id =
                u.idUsuario ??
                u.IdUsuario ??
                u["idUsuario"] ??
                u["IdUsuario"];
              return String(id) === String(sessionUserId);
            }) || null;

          if (!rawUser) {
            const msg = `[RHInbox] No se encontró usuario con idUsuario = ${sessionUserId}`;
            console.warn(msg);
            errors.push(
              "El usuario de sesión no está registrado en el catálogo de usuarios."
            );
          }

          // 2) IdPersona
          const idPersona =
            rawUser?.idPersona ??
            rawUser?.IdPersona ??
            rawUser?.["idPersona"] ??
            rawUser?.["IdPersona"] ??
            null;

          if (!idPersona) {
            const msg =
              "[RHInbox] El usuario de sesión no tiene IdPersona asociado.";
            console.warn(msg, rawUser);
            errors.push(
              "El usuario de sesión no está vinculado a una Persona en el sistema."
            );
          } else {
            // 3) Empleado asociado a esa persona
            const resEmp = await axios.get(endpointEmpleado);
            const empleados = (resEmp.data || []).map(modeloEmpleado);

            const empSesion = empleados.find(
              (e) => e.idPersona === idPersona
            );

            if (!empSesion) {
              const msg = `[RHInbox] No se encontró empleado con idPersona = ${idPersona}`;
              console.warn(msg);
              errors.push(
                "El usuario de sesión no está registrado como Empleado."
              );
            } else {
              // 4) Aprobador(es) asociado(s) a ese empleado
              const resAprob = await axios.get(endpointAprobadores);
              const aprobadores = (resAprob.data || []).map(
                modeloAprobador
              );

              // todas las filas activas para este empleado
              let filasAprobador = aprobadores.filter(
                (a) =>
                  a.idEmpleado === empSesion.idEmpleado &&
                  (a.activo ?? true)
              );

              // si no hay activas, usamos cualquiera para evitar dejarlo "huérfano"
              if (!filasAprobador.length) {
                filasAprobador = aprobadores.filter(
                  (a) => a.idEmpleado === empSesion.idEmpleado
                );
              }

              if (!filasAprobador.length) {
                const msg = `[RHInbox] No se encontró aprobador para el empleado con idEmpleado = ${empSesion.idEmpleado}`;
                console.warn(msg);
                errors.push(
                  "El usuario de sesión no está registrado como Aprobador de reservas."
                );
              } else if (!cancel) {
                // Tomamos la primera fila como "idAprobador principal" para registrar en AprobacionesReservas
                const aprobSesion = filasAprobador[0];

                // Cargamos catálogo de tipos de aprobación
                const resTipos = await axios.get(endpointTipoAprobacion);
                const tiposRaw = (resTipos.data || []).map(
                  modeloTipoAprobacion
                );

                // Guardamos catálogo completo
                setCatalogoTipoAprobacion(tiposRaw);

                // Tipos que puede otorgar este RH (según todas sus filas en CAR_BOOKING.Aprobadores)
                const tiposDelEmpleado = filasAprobador
                  .map((fila) =>
                    tiposRaw.find(
                      (t) =>
                        t.idTipoAprobacion === fila.idTipoAprobacion
                    )
                  )
                  .filter(Boolean);

                setIdAprobadorSesion(aprobSesion.idAprobadores);
                setTiposAprobacionSesion(tiposDelEmpleado);
                setTiposLoaded(true);

                const uoIdsSesion = [
                  ...new Set(
                    (empleadoUnidadOrg || [])
                      .filter((rel) => {
                        const empId = rel.idEmpleado ?? rel.IdEmpleado ?? rel["idEmpleado"] ?? rel["IdEmpleado"] ?? null;
                        return Number(empId) === Number(empSesion.idEmpleado);
                      })
                      .map((rel) =>
                        Number(
                          rel.idUnidadOrganizacional ??
                          rel.IdUnidadOrganizacional ??
                          rel["idUnidadOrganizacional"] ??
                          rel["IdUnidadOrganizacional"] ??
                          0
                        )
                      )
                      .filter(Boolean)
                  ),
                ];
                setAprobadorUoIds(uoIdsSesion);

                console.log("[RHInbox] Aprobador de sesión resuelto:", {
                  idUsuario: sessionUserId,
                  idPersona,
                  idEmpleado: empSesion?.idEmpleado,
                  filasAprobador,
                  tiposDelEmpleado,
                });
              }
            }
          }
        }
      } catch (err) {
        console.error(
          "[RHInbox] Error ligando usuario de sesión a aprobador:",
          err
        );
        errors.push(
          "Ocurrió un error al intentar resolver la información del aprobador para la sesión actual."
        );
      }

      if (cancel) return;

      if (errors.length > 0) {
        // limpiamos info de aprobador para no mostrar datos viejos
        setIdAprobadorSesion(0);
        setTiposAprobacionSesion([]);
        setTiposLoaded(true);
        // Guardamos en estado para bloquear la UI
        setSessionErrors(errors);
        // Mostramos un alert por cada dato faltante / error
        // errors.forEach((msg) => alert(msg));
      } else {
        setSessionErrors([]);
        setTiposLoaded(true);
      }
    }

    loadAprobadorFromSession();

    return () => {
      cancel = true;
    };
  }, [sessionUserId, empleadoUnidadOrg]);

  function handleSelect(r) {
    if (hasSessionErrors) return; // seguridad extra
    setSelected(r);
    setComment("");
  }

  // helper: ¿esta reserva está dentro de los tipos que puede aprobar el usuario?
  const canModifySelected =
    !!selected &&
    !hasSessionErrors &&
    tiposAprobacionSesion.length > 0 &&
    (() => {
      // Si tiene permiso GENERAL (9), puede aprobar cualquier reserva
      const hasGeneralPermission = tiposAprobacionSesion.some(
        (t) => t.idTipoAprobacion === 9
      );

      if (hasGeneralPermission) return true;

      const tipoReserva = getSimulatedApprovalType(selected);

      if (!tipoReserva) return false;
      return tiposAprobacionSesion.some(
        (t) => t.idTipoAprobacion === tipoReserva
      );
    })();

  // ====== Registrar horas extra en MES y SEMANA (siempre INSERT) ======
  const registerExtraHoursForReserva = async (
    idChofer,
    idReserva,
    fechaInicio,
    extraHours
  ) => {
    if (!idChofer || !idReserva || !fechaInicio || !extraHours) return;

    const extraInt = Math.max(0, Math.trunc(Number(extraHours) || 0));
    if (extraInt <= 0) return;

    const fechaStr =
      typeof fechaInicio === "string"
        ? String(fechaInicio).slice(0, 10)
        : formatDateLocal(
          fechaInicio instanceof Date ? fechaInicio : new Date(fechaInicio)
        );

    const d = new Date(fechaStr + "T00:00:00");
    if (Number.isNaN(d.getTime())) return;

    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const week = getISOWeek(d);
    const fechaCorte = new Date().toISOString();

    // ---- MES ----
    try {
      const dtoMes = {
        id: 0, // identity en BD
        idChofer,
        idReserva,
        mes: month,
        anio: year,
        horasExtras: extraInt,
        acumuladas: extraInt,
        fechaCorte,
        activo: true,
      };

      console.log("[RHInbox] Registrando horas extra mensuales:", dtoMes);
      await axios.post(endpointExtrasMes, dtoMes);
    } catch (err) {
      console.error("Error al registrar horas extra mensuales", err);
    }

    // ---- SEMANA ----
    try {
      const dtoSemana = {
        id: 0, // identity en BD
        idReserva,
        idChofer,
        semana: week, // número de semana
        anio: year,
        horasExtras: extraInt,
        horasAcumuladas: extraInt,
        fechaCorte,
        activo: true,
      };

      console.log("[RHInbox] Registrando horas extra semanales:", dtoSemana);
      await axios.post(endpointExtrasSemana, dtoSemana);
    } catch (err) {
      console.error("Error al registrar horas extra semanales", err);
    }

    console.log(`✅ Se registraron ${extraInt} horas extra para el chofer ${idChofer} (Reserva ${idReserva})`);
  };

  // 🔹 Helper para calcular el tipo de aprobación EFECTIVO
  // (Reevalúa si una reserva realmente excede los límites semanal/mensual
  //  tomando en cuenta parámetros laborales vigentes por fecha y UO).


  // PUT al backend para actualizar estado (APROBADA / RECHAZADA)
  async function updateStatus(newStatus) {
    if (!selected) return;
    if (hasSessionErrors) {
      setAlertDialog({
        open: true,
        title: "Error de Sesión",
        message: "No es posible actualizar el estado de la reserva porque falta información crítica del usuario de sesión.",
        variant: "error"
      });
      return;
    }
    if (!canModifySelected) {
      setAlertDialog({
        open: true,
        title: "Acceso Denegado",
        message: "No puedes aprobar o rechazar esta reserva porque no corresponde a tus tipos de aprobación.",
        variant: "error"
      });
      return;
    }

    const idReserva = selected.meta?.idReserva || selected.id;

    // 🔹 Usar las fechas ORIGINALES del meta para evitar problemas de zona horaria
    // NO usar .toISOString() porque convierte a UTC y puede cambiar el día
    const fechaInicioOriginal = selected.meta?.fechaInicio || selected.start.toISOString().split('T')[0];
    const fechaFinOriginal = selected.meta?.fechaFin || selected.end.toISOString().split('T')[0];

    // Las horas sí las tomamos del evento (ya están en formato HH:mm)
    const horaInicio = selected.start.toTimeString().slice(0, 5);
    const horaFin = selected.end.toTimeString().slice(0, 5);

    // Estados:
    // 1 = pendiente, 3 = autorizada, 4 = rechazada
    const idEstadoReserva = newStatus === "APROBADA" ? 3 : 4;

    // 🔹 Calcular ID efectivo (puede cambiar de FueraHorario -> Excedidas)
    const idTipoAprobacionReserva = getSimulatedApprovalType(selected) ??
      selected.meta?.idTipoAprobacionReserva ??
      selected.meta?.idTipoAprobacion ??
      null;

    const payloadReserva = {
      idReserva,
      idSolicitante: selected.meta?.idSolicitante ?? 0,
      idChofer: selected.meta?.idChofer ?? 0,

      fechaInicio: fechaInicioOriginal,
      fechaFin: fechaFinOriginal,
      horaInicio,
      horaFin,

      origenTexto:
        selected.meta?.origenTexto ??
        (selected.meta?.origin
          ? JSON.stringify(selected.meta.origin)
          : ""),
      destinoTexto:
        selected.meta?.destinoTexto ??
        (selected.meta?.destination
          ? JSON.stringify(selected.meta.destination)
          : ""),

      motivo: selected.meta?.motivo || "",
      observaciones: selected.meta?.observaciones || "",

      idEstadoReserva,
      fueraHorarioMin: !!selected.meta?.fueraHorarioMin,

      // si la Reserva tiene columna para el tipo de aprobación, la mandamos
      idTipoAprobacion: idTipoAprobacionReserva,
    };

    try {
      console.log("RH PUT Reserva payload:", payloadReserva);
      await axios.put(endpointReservas, payloadReserva);

      // 🔹 Registrar en CAR_BOOKING.AprobacionesReservas
      if (idAprobadorSesion && idTipoAprobacionReserva) {
        // Si el usuario tiene permiso GENERAL (9), registrar la aprobación con tipo 9
        const hasGeneralPermission = tiposAprobacionSesion.some(
          (t) => t.idTipoAprobacion === 9
        );

        const tipoAprobacionARegistrar = hasGeneralPermission
          ? 9
          : getSimulatedApprovalType(selected); // 🆕 Usar el tipo recalculado en vivo

        const payloadAprob = {
          idReserva,
          idTipoAprobacion: tipoAprobacionARegistrar,
          idEstadoReserva,
          idAprobadores: idAprobadorSesion,
          comentario: comment || "",
        };
        console.log(
          "RH POST AprobacionesReservas payload:",
          payloadAprob
        );
        await axios.post(endpointAprobaciones, payloadAprob);
      } else if (!idAprobadorSesion) {
        console.warn(
          "[RHInbox] No se tiene idAprobador para el usuario de sesión; no se registra en AprobacionesReservas."
        );
        setAlertDialog({
          open: true,
          title: "Error",
          message: "No se encontró el aprobador asociado al usuario de sesión. No es posible registrar la aprobación o rechazo.",
          variant: "error"
        });
      } else {
        console.warn(
          "[RHInbox] No se encontró idTipoAprobacion para la reserva seleccionada."
        );
        setAlertDialog({
          open: true,
          title: "Error",
          message: "No se pudo determinar el tipo de aprobación de la reserva. No se registró la aprobación/rechazo.",
          variant: "error"
        });
      }


      // 🆕 Registrar horas extras SOLO si se APRUEBA la reserva
      if (newStatus === "APROBADA" && idTipoAprobacionReserva) {
        const idChofer = selected.meta?.idChofer;

        // 🎯 IMPORTANTE: Usar el valor ya calculado en 'load' que es el más robusto (manejando fin de semana, festivos y multi-día)
        const extraHours = Number(selected.meta?.horasExtraNetas) || 0;

        console.log(`[RHInbox] Registrando ${extraHours} horas extra definitivas (procedentes de meta.horasExtraNetas)`);

        if (extraHours > 0) {
          // Usar la función helper para registrar las horas extras
          await registerExtraHoursForReserva(
            idChofer,
            idReserva,
            selected.start,
            extraHours
          );
        } else {
          console.log(`[RHInbox] No hay horas extras que registrar (extraHours = 0)`);
        }
      }


      // 🆕 RECALCULAR Y ACTUALIZAR TIPOS DE APROBACIÓN DE RESERVAS PENDIENTES DEL MISMO CHOFER
      if (newStatus === "APROBADA") {
        const choferId = selected.meta?.idChofer;

        if (choferId) {
          console.log(`\n========================================`);
          console.log(`[RHInbox] 🔄 INICIANDO RECALCULACIÓN DE TIPOS DE APROBACIÓN`);
          console.log(`[RHInbox] Chofer ID: ${choferId}`);
          console.log(`[RHInbox] Reserva aprobada ID: ${idReserva}`);
          console.log(`========================================\n`);

          // 1. Recargar datos frescos (con las horas extras ya registradas)
          console.log(`[RHInbox] 📥 Recargando datos frescos...`);
          const latestEvents = await load();
          console.log(`[RHInbox] ✅ Datos recargados. Total eventos: ${latestEvents?.length || 0}`);

          if (latestEvents && latestEvents.length > 0) {
            // 2. Filtrar reservas PENDIENTES del mismo chofer (excluyendo la que acabamos de aprobar)
            const pendingSiblings = latestEvents.filter(ev =>
              ev.meta?.idChofer === choferId &&
              Number(ev.meta?.idEstadoReserva) === 1 && // Solo pendientes
              ev.id !== idReserva // Excluir la recién aprobada
            );

            console.log(`\n[RHInbox] 📋 Reservas pendientes del chofer encontradas: ${pendingSiblings.length}`);

            if (pendingSiblings.length > 0) {
              console.log(`[RHInbox] Detalles de reservas pendientes:`);
              pendingSiblings.forEach((sib, idx) => {
                console.log(`  ${idx + 1}. ID: ${sib.id}, Tipo actual: ${sib.meta?.idTipoAprobacion}, Horas netas: ${sib.meta?.horasExtraNetas}h`);
              });
            }

            let updatesMade = false;

            // 3. Para cada reserva pendiente, recalcular su tipo de aprobación
            for (const sib of pendingSiblings) {
              console.log(`\n[RHInbox] 🔍 Analizando reserva #${sib.id}...`);

              // Calcular el tipo correcto usando los datos frescos
              console.log(`[RHInbox]   🔧 Llamando a getSimulatedApprovalType...`);
              console.log(`[RHInbox]   - latestEvents.length: ${latestEvents.length}`);
              console.log(`[RHInbox]   - sib.id: ${sib.id}`);

              const newTypeId = getSimulatedApprovalType(sib, latestEvents);

              console.log(`[RHInbox]   ✅ getSimulatedApprovalType retornó: ${newTypeId}`);

              const currentTypeId = sib.meta?.idTipoAprobacionReserva || sib.meta?.idTipoAprobacion;

              console.log(`[RHInbox]   Tipo actual en BD: ${currentTypeId}`);
              console.log(`[RHInbox]   Tipo calculado: ${newTypeId}`);
              console.log(`[RHInbox]   Horas netas de esta reserva: ${sib.meta?.horasExtraNetas}h`);

              // Si el tipo calculado es diferente al almacenado, actualizar
              if (newTypeId && newTypeId !== currentTypeId) {
                console.log(`[RHInbox]   ⚠️ TIPO CAMBIÓ: ${currentTypeId} → ${newTypeId}`);
                console.log(`[RHInbox]   📝 Preparando actualización...`);

                try {
                  const updatePayload = {
                    idReserva: sib.id,
                    idSolicitante: sib.meta?.idSolicitante ?? 0,
                    idChofer: sib.meta?.idChofer ?? 0,
                    fechaInicio: sib.meta?.fechaInicio,
                    fechaFin: sib.meta?.fechaFin,
                    horaInicio: sib.start.toTimeString().slice(0, 5),
                    horaFin: sib.end.toTimeString().slice(0, 5),
                    origenTexto: sib.meta?.origenTexto ??
                      (sib.meta?.origin ? JSON.stringify(sib.meta.origin) : ""),
                    destinoTexto: sib.meta?.destinoTexto ??
                      (sib.meta?.destination ? JSON.stringify(sib.meta.destination) : ""),
                    motivo: sib.meta?.motivo || "",
                    observaciones: sib.meta?.observaciones || "",
                    idEstadoReserva: 1, // Mantener como PENDIENTE
                    fueraHorarioMin: !!sib.meta?.fueraHorarioMin,
                    idTipoAprobacion: newTypeId // 🎯 ACTUALIZAR EL TIPO
                  };

                  console.log(`[RHInbox]   📤 Enviando PUT a backend...`);
                  console.log(`[RHInbox]   Payload:`, JSON.stringify(updatePayload, null, 2));

                  const response = await axios.put(endpointReservas, updatePayload);

                  updatesMade = true;
                  console.log(`[RHInbox]   ✅ Reserva #${sib.id} actualizada correctamente`);
                  console.log(`[RHInbox]   Respuesta del servidor:`, response.status, response.statusText);
                } catch (updateErr) {
                  console.error(`[RHInbox]   ❌ ERROR actualizando reserva #${sib.id}:`);
                  console.error(`[RHInbox]   Error completo:`, updateErr);
                  console.error(`[RHInbox]   Mensaje:`, updateErr.message);
                  console.error(`[RHInbox]   Response:`, updateErr.response?.data);
                }
              } else {
                console.log(`[RHInbox]   ℹ️ No requiere actualización (tipo correcto)`);
              }
            }

            // 4. Si hubo actualizaciones, recargar una vez más para reflejar los cambios en la UI
            if (updatesMade) {
              console.log(`\n[RHInbox] 🔄 Se realizaron actualizaciones a otros viajes.`);
            } else {
              console.log(`\n[RHInbox] ℹ️ No se requirieron actualizaciones de tipos de aprobación`);
            }
          } else {
            console.log(`[RHInbox] ⚠️ No se obtuvieron eventos después de recargar`);
          }

          console.log(`\n========================================`);
          console.log(`[RHInbox] ✅ RECALCULACIÓN COMPLETADA`);
          console.log(`========================================\n`);
        } else {
          console.log(`[RHInbox] ⚠️ No se pudo obtener el ID del chofer de la reserva aprobada`);
        }
      }

      setSelected(null);
      setComment("");
      await load();
    } catch (err) {
      console.error(err);
      setAlertDialog({
        open: true,
        title: "Error",
        message: "Error al actualizar el estado de la reserva",
        variant: "error"
      });
    }
  }

  async function handleApprove() {
    // Validar que el comentario no esté vacío
    if (!comment || !comment.trim()) {
      setAlertDialog({
        open: true,
        title: "Aviso",
        message: "El comentario es obligatorio para aprobar una solicitud.",
        variant: "info"
      });
      return;
    }
    await updateStatus("APROBADA");
  }

  async function handleReject() {
    if (!selected) return;
    if (hasSessionErrors) {
      setAlertDialog({
        open: true,
        title: "Error de Sesión",
        message: "No es posible rechazar la solicitud porque falta información crítica del usuario de sesión.",
        variant: "error"
      });
      return;
    }
    if (!canModifySelected) {
      setAlertDialog({
        open: true,
        title: "Acceso Denegado",
        message: "No puedes rechazar esta solicitud porque no corresponde a tus tipos de aprobación.",
        variant: "error"
      });
      return;
    }
    // Validar que el comentario no esté vacío
    if (!comment || !comment.trim()) {
      setAlertDialog({
        open: true,
        title: "Aviso",
        message: "El comentario es obligatorio para rechazar una solicitud.",
        variant: "info"
      });
      return;
    }

    setConfirmDialog({
      open: true,
      title: "Rechazar solicitud",
      message: "¿Estás seguro de que deseas RECHAZAR esta solicitud? Esta acción no se puede deshacer.",
      variant: "default",
      confirmText: "Rechazar", // Explicitly name the button action
      onConfirm: async () => {
        await updateStatus("RECHAZADA");
        setConfirmDialog({ ...confirmDialog, open: false });
      },
    });
  }

  // Helpers para mostrar origen/destino como texto del DTO
  const getOrigenTexto = (meta) => {
    const raw = meta?.origenTexto;
    if (!raw) return meta?.origin?.address || "No capturado";

    try {
      const parsed = JSON.parse(raw);
      return parsed?.address || raw;
    } catch {
      // si no es JSON, usamos el texto plano o el origin.address
      return raw || meta?.origin?.address || "No capturado";
    }
  };

  const getDestinoTexto = (meta) => {
    const raw = meta?.destinoTexto;
    if (!raw) return meta?.destination?.address || "No capturado";

    try {
      const parsed = JSON.parse(raw);
      return parsed?.address || raw;
    } catch {
      return raw || meta?.destination?.address || "No capturado";
    }
  };

  const getNombreTipoAprobacion = (ev) => {
    if (!ev) return "N/A";

    // Usar lógica simulada
    const tipoId = getSimulatedApprovalType(ev);

    if (!tipoId) return "N/A";

    const cat = catalogoTipoAprobacion.find(
      (t) => t.idTipoAprobacion === tipoId
    );

    return cat?.nombre || `Tipo ${tipoId}`;
  };


  const getNombreTipoAprobacionSimulado = (res) => {
    const typeId = getSimulatedApprovalType(res);
    switch (typeId) {
      case TIPO_APROBACION.FUERA_HORARIO: return "Fuera de Horario";
      case TIPO_APROBACION.HORAS_SEMANA_EXCEDIDAS: return "Horas Semanales Excedidas";
      case TIPO_APROBACION.HORAS_MES_EXCEDIDAS: return "Horas Mensuales Excedidas";
      case TIPO_APROBACION.FIN_SEMANA: return "Fin de Semana";
      case TIPO_APROBACION.DIAS_FESTIVOS: return "Días Festivos";
      case TIPO_APROBACION.VARIOS_DIAS: return "Viaje de Varios Días";
      case TIPO_APROBACION.GENERAL: return "General (Admin)";
      default: return "Desconocido";
    }
  };

  return (
    <div className="page rh-page">
      <header className="rh-card">
        <div className="user reservation-section__title" style={{ width: "100%" }}>
          Aprobaciones de Reservas
          {tiposAprobacionSesion.length > 0 && (
            <span
              className="rh-permisos"
              style={{
                marginLeft: "0.75rem",
                fontSize: "0.8rem",
                opacity: 0.9,
                float: "right",
              }}
            >
              Tipos de aprobación:&nbsp;
              {tiposAprobacionSesion.map((t) => t.nombre).join(" · ")}
            </span>
          )}
        </div>
      </header>

      <main className="rh-content">
        {hasSessionErrors ? (
          // 🔒 Bloqueo total - UI mejorada
          <div style={{
            gridColumn: '1 / -1',  // Ocupar todas las columnas del grid
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            minHeight: '80vh', padding: '2rem', width: '100%'
          }}>
            <div className="card" style={{
              maxWidth: '1100px', width: '100%',
              padding: '3rem',
              borderRadius: '16px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              backgroundColor: '#fff',
              textAlign: 'center',
              borderTop: '5px solid #ef4444'
            }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                backgroundColor: '#fee2e2', color: '#dc2626',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 1.5rem auto', fontSize: '32px'
              }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <h2 style={{
                fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937',
                marginBottom: '1rem'
              }}>
                Acceso Restringido - Recursos Humanos
              </h2>
              <p style={{
                fontSize: '1rem', color: '#6b7280', marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                No cumples con todos los requisitos necesarios para operar esta bandeja de aprobaciones.
                Por favor, contacta al área de sistemas para verificar tu configuración.
              </p>

              <div style={{
                textAlign: 'left',
                background: '#fef2f2',
                padding: '1.5rem',
                borderRadius: '12px',
                border: '1px solid #fecaca'
              }}>
                <h4 style={{
                  margin: '0 0 1rem 0',
                  color: '#991b1b',
                  fontSize: '1rem',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                  Requisitos faltantes:
                </h4>
                <ul style={{
                  paddingLeft: '1.5rem',
                  margin: 0,
                  color: '#b91c1c',
                  lineHeight: '1.8'
                }}>
                  {sessionErrors.map((msg, idx) => (
                    <li key={idx} style={{ marginBottom: '0.5rem' }}>{msg}</li>
                  ))}
                </ul>
              </div>

              <div style={{
                marginTop: '2rem',
                padding: '1rem',
                background: '#f9fafb',
                borderRadius: '8px',
                fontSize: '0.875rem',
                color: '#4b5563'
              }}>
                <strong>Para acceder necesitas:</strong>
                <ul style={{ textAlign: 'left', marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
                  <li>Estar registrado como Usuario activo</li>
                  <li>Tener una Persona asociada</li>
                  <li>Estar registrado como Empleado</li>
                  <li>Estar configurado como Aprobador de reservas</li>
                </ul>
              </div>

              <div style={{ marginTop: '2rem' }}>
                <button
                  className="btn-action"
                  onClick={() => window.location.reload()}
                  style={{
                    backgroundColor: '#10b981', color: '#fff', border: 'none',
                    padding: '0.6rem 1.2rem', borderRadius: '8px', cursor: 'pointer',
                    fontWeight: '600', transition: 'all 0.2s', marginTop: '1rem'
                  }}
                >
                  Recargar Página
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <aside className="rh-list card">
              <div className="rh-list-head" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '1rem', marginBottom: '1rem' }}>
                <h2 style={{ fontSize: '1.2rem', color: '#1e293b', margin: 0 }}>
                  {pending.length} {pending.length === 1 ? 'petición faltante' : 'peticiones faltantes'}
                </h2>
              </div>
              <div className="rh-list-head" style={{ padding: '0.5rem 0' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: '0.75rem' }}>
                  <span style={{ fontSize: '0.9rem', color: '#64748b', fontWeight: 500 }}>Ver todas las solicitudes</span>
                  <div
                    onClick={() => setShowAll((s) => !s)}
                    style={{
                      width: '34px',
                      height: '18px',
                      backgroundColor: showAll ? '#10b981' : '#cbd5e1',
                      borderRadius: '12px',
                      position: 'relative',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                      flexShrink: 0
                    }}
                  >
                    <div style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      position: 'absolute',
                      top: '3px',
                      left: showAll ? '19px' : '3px',
                      transition: 'left 0.2s',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                    }} />
                  </div>
                </div>
              </div>
              <div className="rh-list-body">
                {pending.length === 0 && (
                  <div className="rh-empty">
                    No hay solicitudes pendientes 👌
                  </div>
                )}
                {pending.map((r) => {
                  // Determinar si el usuario tiene permiso para este tipo de aprobación
                  const canModifyItem = tiposAprobacionSesion.some(t => t.idTipoAprobacion === 9) ||
                    tiposAprobacionSesion.some(t => t.idTipoAprobacion === getSimulatedApprovalType(r));

                  const isSelected = selected && selected.id === r.id;

                  return (
                    <button
                      key={r.id}
                      className={
                        "rh-item " +
                        (isSelected ? "active" : "")
                      }
                      onClick={() => handleSelect(r)}
                      style={{
                        background: isSelected
                          ? 'rgba(255, 255, 255, 0.5)'
                          : (!canModifyItem ? '#f1f5f9' : 'transparent'),
                        opacity: !canModifyItem ? 0.7 : 1,
                        border: isSelected
                          ? '2px solid var(--color-primary)'
                          : (canModifyItem ? '1px solid var(--color-primary)' : '1px solid #cbd5e1'),
                        borderRadius: '6px',
                        marginBottom: '0.5rem',
                        padding: '0.75rem',
                        filter: !canModifyItem ? 'grayscale(0.4)' : 'none',
                        cursor: 'pointer'
                      }}
                    >

                    <label className="reservation-section__title" style={{ display: 'block', marginBottom: '0.75rem' }}>
                      Número de Solicitud: {r.id}
                    </label>

                    {/* Chofer primero */}
                    <label className="rh-item-title form-group " style={{ color: 'var(--color-primary)' }}>
                      Chofer:
                    </label>
                    <div style={{
                      fontSize: '0.95rem',
                      color: '#1e293b',
                      fontWeight: 400,
                      padding: '0.5rem 0',
                      marginBottom: '0.5rem'
                    }}>
                      {r.meta.chofer || "N/D"}
                    </div>

                    {/* Permiso Necesario después */}
                    <label className="rh-item-title form-group " style={{ color: 'var(--color-primary)' }}>
                      Permiso necesario:
                    </label>
                    <div style={{
                      fontSize: '0.95rem',
                      color: '#1e293b',
                      fontWeight: 400,
                      padding: '0.5rem 0',
                      marginBottom: '0.5rem'
                    }}>
                      {getNombreTipoAprobacionSimulado(r)}
                    </div>

                  </button>
                );
              })}

              </div>
            </aside>

            <section className="rh-detail card">
              {!selected ? (
                <div className="rh-detail-empty">
                  Selecciona una solicitud para revisarla
                </div>
              ) : (
                <>
                  <div className="reservation-section__title">
                    <h2>
                      Solicitud de{" "}
                      {selected.meta?.nombre || `#${selected.id}`}
                    </h2>
                  </div>
                  <div className="rh-detail-head">
                    <span className="badge warn">PENDIENTE</span>
                  </div>

                  {showAll && selected && !canModifySelected && (
                    <p
                      className="rh-warning"
                      style={{ color: "#b45309", marginBottom: "0.75rem" }}
                    >
                      Esta solicitud no corresponde a tus tipos de aprobación.
                      Solo puedes visualizarla.
                    </p>
                  )}

                  <div className="rh-grid">
                    <div>
                      <label className="rh-item-title form-group">Fecha y hora</label>
                      <p className="rh-value">
                        {formatDateTimeRange(selected.start, selected.end)}
                      </p>
                    </div>

                    <div>
                      <label className="rh-item-title form-group">Chofer solicitado</label>
                      <p className="rh-value">
                        {selected.meta?.chofer || "N/A"}
                      </p>
                    </div>

                    {/* Solicitante (nombre + correo) */}
                    <div>
                      <label className="rh-item-title form-group">Solicitante</label>
                      <p className="rh-value">
                        {selected.meta?.nombre || "N/A"}
                        {selected.meta?.emailSolicitante && (
                          <>
                            <br />
                            <span className="rh-email">
                              {selected.meta.emailSolicitante}
                            </span>
                          </>
                        )}
                      </p>
                    </div>

                    {/* Origen con origenTexto */}
                    <div>
                      <label className="rh-item-title form-group">Origen</label>
                      <p className="rh-value">
                        {getOrigenTexto(selected.meta)}
                      </p>
                    </div>

                    {/* Destino con destinoTexto */}
                    <div>
                      <label className="rh-item-title form-group">Destino</label>
                      <p className="rh-value">
                        {getDestinoTexto(selected.meta)}
                      </p>
                    </div>

                    {/* Motivo como “columna” extra */}
                    <div>
                      <label className="rh-item-title form-group">Motivo del viaje</label>
                      <p className="rh-value">
                        {selected.meta?.motivo || "Sin motivo"}
                      </p>
                    </div>

                    <div>
                      <label className="rh-item-title form-group">
                        Tipo de Aprobación Necesaria
                      </label>
                      <p className="rh-value">
                        {getNombreTipoAprobacionSimulado(selected)}
                      </p>
                    </div>



                    <div>
                      <label className="rh-item-title form-group">
                        Comentarios del solicitante
                      </label>
                      <p className="rh-value">
                        {selected.meta?.observaciones || "Sin comentarios"}
                      </p>
                    </div>

                    {/* 🆕 Horas extra netas de esta reserva */}
                    <div>
                      <label className="rh-item-title form-group">
                        Horas extra netas de esta reserva
                      </label>
                      <p className="rh-value">
                        {Math.floor(Number(selected.meta?.horasExtraNetas) || 0)} h
                      </p>
                    </div>

                    {/* Horas extra separadas: semana / mes */}
                    <div>
                      <label className="rh-item-title form-group">
                        Horas extra (semana)
                      </label>
                      <p className="rh-value">
                        {Math.floor(Number(selected.meta?.extrasSemanaHoras) || 0)} h
                      </p>
                    </div>

                    <div>
                      <label className="rh-item-title form-group">Horas extra (mes)</label>
                      <p className="rh-value">
                        {Math.floor(Number(selected.meta?.extrasMesHoras) || 0)} h
                      </p>
                    </div>
                  </div>

                  <div className="rh-comment-block">
                    <label className="rh-item-title form-group" style={{ display: 'block' }}>
                      Comentario de RH <span style={{ color: 'red' }}>*</span>
                    </label>
                    <textarea
                      rows={3}
                      className="rh-textarea"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Este comentario es obligatorio y se guardará en el registro de aprobación/rechazo"
                      disabled={!canModifySelected}
                    />
                  </div>

                  <div className="rh-actions">
                    <button
                      className="btn-cancel"
                      onClick={handleReject}
                      disabled={!canModifySelected || !comment.trim()}
                    >
                      Rechazar
                    </button>
                    <button
                      className="btn-action"
                      onClick={handleApprove}
                      disabled={!canModifySelected || !comment.trim()}
                    >
                      Aprobar
                    </button>
                  </div>
                </>
              )}
            </section>
          </>
        )}
      </main >

      {
        confirmDialog.open && (
          <ConfirmDialog
            open={confirmDialog.open}
            onClose={() => setConfirmDialog(prev => ({ ...prev, open: false }))}
            title={confirmDialog.title}
            message={confirmDialog.message}
            variant={confirmDialog.variant}
            onConfirm={confirmDialog.onConfirm}
          />
        )}

      <AlertDialog
        open={alertDialog.open}
        title={alertDialog.title}
        message={alertDialog.message}
        variant={alertDialog.variant}
        onClose={() => {
          setAlertDialog({ ...alertDialog, open: false });
          if (alertDialog.onConfirm) alertDialog.onConfirm();
        }}
        buttonText="Aceptar"
      />
    </div >
  );
}
